import Vue from "vue";
import { Toast } from "vant";
import jquery from "jquery";
Vue.use(Toast);
/* window.JsInterace = { // 此处是android分享完毕之后的回调函数
  //分享失败回调
  shareerrorback:function(){

  },
  //分享成功回调
  sharesuccessback: function(){

  },
  //分享取消回调
  sharecancleback:function(){

  }
}*/
export default {
  login: function login(cuserid, userno, usename, txuser, usig) {
    // 登录
    return JSON.parse(window.AppInterace.login(cuserid, userno, usename, txuser, usig));
  },
  autologin: function autologin() {
    // 自动登录
    return JSON.parse(window.AppInterace.autologin());
  },
  logout: function logout() {
    // 注销
    return JSON.parse(window.AppInterace.logout());
  },
  getCurrentUser: function getCurrentUser() {
    // 获取用户信息
    return JSON.parse(window.AppInterace.getCurrentUser());
  },
  setTab: function setTab(x) {
    // 导航条跳转
    return JSON.parse(window.AppInterace.setTab(x));
  },
  goUrl: function goUrl(url) {
    // 当前tab页面跳转
    return JSON.parse(window.AppInterace.goUrl(url));
  },
  alert: function alert(message) {
    // 弹框
    window.AppInterace.ToastDialog("", message, 0, 1000);
  },
  getServer: function getServer() {
    // 获取服务器信息
    return JSON.parse(window.AppInterace.getServer());
  },
  getappurl: function getappurl() {
    // 获取app本地html路径
    return JSON.parse(window.AppInterace.Getappurl());
  },
  alipayforOrder: function alipayforOrder(code, callback) {
    // 支付宝支付
    return JSON.parse(window.AppInterace.alipay(code, callback));
  },
  wxpayforOrder: function wxpayforOrder(code, callback) {
    // 微信支付
    return window.AppInterace.wxpay(code, callback);
  },
  shareMsg: function shareMsg(params) {
    // 分享
    return window.AppInterace.shareMsg(params.url, params.title, params.text, params.path);
  },
  getCatchSize: function getCatchSize() {
    // 获取缓存大小
    return JSON.parse(window.AppInterace.getCatchSize());
  },
  clearCatche: function clearCatche() {
    // 清除缓存
    return JSON.parse(window.AppInterace.clearCatche());
  },
  setNavbarVisiable: function setNavbarVisiable(x) {
    // 底部导航条 0：隐藏原生导航 1：显示原生导航
    return JSON.parse(window.AppInterace.setNavbarVisiable(x));
  },
  downloadImg: function downloadImg(url) {
    // 保存图片到本地
    return JSON.parse(window.AppInterace.downloadImg(url));
  },
  getAppInfo: function getAppInfo() {
    // 获取app 信息
    return JSON.parse(window.AppInterace.GetAppInfo());
  },
  currentLocation: function (fun) { // 位置
    return JSON.parse(window.AppInterace.CurrentLocation(fun));
  },
  add: function (a, b) { // 加
    return JSON.parse(window.AppInterace.add(a, b));
  },
  sub: function (a, b) { // 减
    return JSON.parse(window.AppInterace.sub(a, b));
  },
  mul: function (a, b) { // 乘
    return JSON.parse(window.AppInterace.mul(a, b));
  },
  div: function (a, b) { // 除
    return JSON.parse(window.AppInterace.div(a, b));
  },
  screenRecorder(type, recordCallback, progressCallback) { // 录屏
    return JSON.parse(window.AppInterace.screenRecorder(type, recordCallback, progressCallback));
  },
  FilePick(single, filePickSuccessCallback, filePickProgressCallback) { // 文件上传
    return JSON.parse(window.AppInterace.FilePick('', single, 'pos1', filePickSuccessCallback, filePickProgressCallback));
  },
  setScreenOrientation(type) { // 横竖屏切换
    return JSON.parse(window.AppInterace.setScreenOrientation(type));
  },
  // ----------------以上是安卓app要使用的方法
  /**
   * @author 宋建国
   * @param {object} o - 传进来的对象参数
   * @returns 直接下载文件
   * @version 1.0.0
   * @description 通用文件下载函数
   * @public
   * */
  downloadfile: function (res) {
    // 处理返回的文件流
    const blob = new Blob([res.data], {
      type: "application/vnd.ms-excel;charset=utf-8"
    });
    if ("download" in document.createElement("a")) {
      // 非IE下载
      const elink = document.createElement("a");
      elink.download = decodeURIComponent(res.filename);
      elink.style.display = "none";
      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    } else {
      // IE10+下载
      navigator.msSaveBlob(blob, decodeURIComponent(res.filename));
    }
  },
  /**
   * @author 宋建国
   * @param {object} row - 表格行数据
   * @param {object} column - 表格列数据
   * @param {string} cellValue - 当前单元格数据
   * @returns {string} 返回审批对应的中文
   * @description 审批状态文字显示
   * @public
   * @verson 1.0.0
   * */
  applyStateChine: function (row, column, cellValue) {
    switch (cellValue) {
      case '0':
        return "未提交";
        break;
      case '1':
        return "审批中";
        break;
      case '2':
        return "选择驳回";
        break;
      case '3':
        return "审批完成";
        break;
      case '4':
        return "终止";
        break;
      case '5':
        return "挂起";
        break;
      case '6':
        return "驳回发起人";
        break;
      case '7':
        return "驳回上一级";
        break;
      case '8':
        return "转办";
        break;
      case '9':
        return "选签";
        break;
      case '10':
        return "无需审批";
        break;
      default:
        return cellValue;
    }
  },
  /**
   * @author 张俊娜
   * @description 生成13位唯一随机数
   * @verson 1.0.0
   * @return {string} 返回一个随机数
   */
  createRandom: function () {
    return Number(Math.random() + Date.now()).toString().substr(0, 13)
  },

  /**
   * @author 张俊娜
   * @param {array} arr - 需要递归的数组
   * @param {string} label - 需要获取的字段名
   * @param {string} value - 需要递归的子级的字段名
   * @returns {array} 返回要找的字段组成的数组
   * @description 递归获取所有子级的某个字段值
   * @public
   * @verson 1.0.0
   * */
  recursive: function (arr, label, value, ary = []) {    
    arr.forEach(item => {
      ary.push(item[label])
      if (item[value] && item[value].length > 0) {
        this.recursive(item[value], label, value, ary)
      }
    })
    return ary;
  },

  /**
   * @author 宋建国
   * @param {array} array - 需要判断的数组
   * @returns {Boolean} 如果是数组 那么返回true 否则返回false
   * @version 1.0.0
   * @description 判断是否是数组
   * @public
   **/
  isArray: function (array) {
    if (Object.prototype.toString.call(array) === '[object Array]') {
      return true;
    } else {
      return false;
    }
  },

  /**
   * @author 宋建国
   * @param {object} obj - 需要判断的对象
   * @returns {Boolean} 如果是对象 那么返回true 否则返回false
   * @version 1.0.0
   * @description 判断是否是对象
   * @public
   **/
  isObj: function (obj) {
    return Object.prototype.toString.call(obj) === '[object Object]' ? true : false;
  },

  /**
   * @author 宋建国
   * @param {object} obj - 需要克隆的对象
   * @returns {object} 返回克隆后的对象
   * @version 1.0.0
   * @description 对象深度克隆
   * @public
   **/
  xyjClone: function (obj) {
    let result;
    let oClass = this.isClass(obj);
    if (oClass === "Object") {
      result = {};
    } else if (oClass === "Array") {
      result = [];
    } else {
      return obj;
    }
    for (var key in obj) {
      var copy = obj[key];
      if (this.isClass(copy) == "Object") {
        result[key] = this.xyjClone(copy); //递归调用
      } else if (this.isClass(copy) == "Array") {
        result[key] = this.xyjClone(copy);
      } else {
        result[key] = obj[key];
      }
    }
    return result;
  },
/**@description: 深度合并对象
 *@functionName: ObjectMerge
 *@params1: target 目标对象
 *@params2: 被合并对象
 *@author: 宋建国
 *@date: 2021-06-17 23:14:20
 *@version: V1.0
*/
ObjectMerge: function(target, source) { // 深度合并对象
  // debugger;
  //宋建国，整段实现了，将原数组的第一个元素，合并到目标数组中，如果目标数据存在，则使用目标数据
  function ArrayMerge(Atarget,Asource){
    //宋建国，判断合并目标数值是否存在，如果不存在说明数据为空，不需要处理；
    if(this.isBlank(Atarget)){
      Atarget=[];
      return;
    }
    //如果数组中没有数据，不需要处理
    if(Atarget.length<=0){
      return;
    }
    let tmpSource0 = [];
    if(Asource.length>0){
      tmpSource0.push(Asource[0]);
    }
    if(tmpSource0.length>0){
      for(let i=0; i<Atarget.length; i++){
          this.ObjectMerge(Atarget[i],tmpSource0[0]);
      }
    }
  }
  if(Array.isArray(source)){
    ArrayMerge.call(this,target,source);
  }else if(source.toString() === "[object Object]"){
    for (var key in source) {
      if(source[key].toString() === "[object Object]"){
        if(target[key]){
          this.ObjectMerge(target[key],source[key]);
        }else{
          target[key] = JSON.parse(JSON.stringify(source[key]));
        }
      }else if (Array.isArray(source[key])){
        if(this.isBlank(target[key])){
          target[key] = source[key];
        }
        ArrayMerge.call(this,target[key],source[key]);
      }else{
        if(target[key]){

        }else{
          target[key] = source[key];
        }
      }
    }
  }
  return target;
},


  /**
   * @author 宋建国
   * @param {object | number | string | array} o - 任意值
   * @returns {string} 返回描述某个对象数据类型的字符串
   * @version 1.0.0
   * @description 获取数据类型
   * @public
   **/
  isClass: function (o) {
    if (o === null) return "Null";
    if (o === undefined) return "Undefined";
    return Object.prototype.toString.call(o).slice(8, -1);
  },

  /**
   * @author 宋建国
   * @param {object} then - 当前this对象
   * @returns {object} 返回一个对象 {width:number,height:number}
   * @version 1.0.0
   * @description 获取屏幕宽高
   * @public
   **/
  screenWH: function (then) {
    let result = null;
    if (then.$tu.isBlank(then.$store.state.app.drapRoutePath)) {
      result = {
        width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
        height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      }
    } else {
      result = {
        width: 414,
        height: 736
      }
    }
    return result;
  },

  /**
   * @author 张俊娜
   * @param {array} arr - 需要去重的数组
   * @param {string} name - 需要去重的字段
   * @returns {array} 返回去重后的新数组
   * @version 1.0.0
   * @description 对数组本身进行某个字段的去重
   * @public
   **/
  distinct: function (arr, name) {
    var hash = {};
    return arr.reduce(function (item, next) {
      hash[next[name]] ? '' : hash[next[name]] = true && item.push(next);
      return item;
    }, []);
  },
  /**
   * @author 张俊娜
   * @param {array} arr - 需要删除的数组
   * @param {string} name - 需要删除的条件字段
   * @param {string} value - 需要删除的条件字段等于的值
   * @returns {array} 返回删除后的新数组
   * @version 1.0.0
   * @description 删除数组中某个字段等于特定值的一条数据
   * @public
   **/
  delArrary(arr, name, value) {
    return arr.filter(element => { return element[name] != value });
  },
  // ----------------以上是Pc要使用的方法
  /* 判断对象是否为空*/
  isObjectBlank: function (o) {
    for (var n in o) {
      return false;
    }
    return true;
  },
  /**
   *宋建国：2019/8/9 18:57
   *描述：判断变量是否为空
   *版本：1.0
   */
  isBlank: function (value) {
    if (value === "" || value === null || value === undefined) { // "",null,undefined
      return true;
    } else {
      return false;
    }
  },
  // 判断是不是函数
  isFunction: function (FunName) {
    try {
      if (typeof FunName === "function") { // 是函数    其中 FunName 为函数名称
        return true;
      } else { // 不是函数
        return false;
      }
    } catch (e) {
      console.warn("isFunction方法判断是否是函数错误：" + e);
      return false;
    }
  },
  /*
   * @params datetime 传递进来的日期
   * @params isSelfDefined 是否自定义日期格式
   * @params dateSeprator 自定义格式下 年月日中间的分割符号
   * @params timeSeprator 自定义格式下 时分秒中间的分割符号
   * */
  formatymd: function (datetime, isSelfDefined, dateSeprator, timeSeprator) { // 将 2018-09-23T11:54:16.000+0000 格式化成类似 2018/09/23 11:54:16； / 和 ： 可以自定义
    try {        
      const dateMat = new Date(datetime);
      const year = dateMat.getFullYear();
      const month = dateMat.getMonth() + 1;
      const day = dateMat.getDate();
      const that = this;

      function formatWithSeperator(datetime, dateSeprator, timeSeprator) { // 转化为时分秒的日期格式
        if (datetime != null) {
          const year = dateMat.getFullYear();
          const month = that.formatNumber(dateMat.getMonth() + 1);
          const day = that.formatNumber(dateMat.getDate());
          const hh = that.formatNumber(dateMat.getHours());
          const mm = that.formatNumber(dateMat.getMinutes());
          const ss = that.formatNumber(dateMat.getSeconds());
          const timeFormat = year + dateSeprator + month + dateSeprator + day + " " + hh + timeSeprator + mm + timeSeprator + ss;
          return timeFormat;
        }
      }
      if (isSelfDefined) {
        if (!timeSeprator) {
          timeSeprator = ":";
        }
        if (!dateSeprator) {
          dateSeprator = "/";
        }
        return formatWithSeperator(datetime, dateSeprator, timeSeprator);
      }
      return [year, month, day].map(this.formatNumber).join("-");
    } catch (e) {
      return new Error("请检查日期是否传入或者格式是否正确，如果还未解决请联系管理员。");
    }
  },
  formatNumber: n => {
    n = n.toString();
    return n[1] ? n : "0" + n;
  },
  /* 获取要截取字符的长度，因为中文和英文的字符长度不一致
   * @params Str 传递进来的字符串
   * @params n 打算要截取的位数
   * @params needPoint 是否需要添加省略号 默认是true
   * @return {
   * 	selflen: 整个字符串字符的长度
   *  limitIndex: 应该在那个下标处截取此字符串
   *  str： 截取之后的字符串
   * }
   * */
  getString: function (Str, n, needPoint) {
    var len = 0;
    var code = 0;
    var limit = 0;
    var state = true;
    var num = n || 10;
    if (typeof Str !== "string") return new Error("你传进来的根本就不是一个字符串！");
    for (let i = 0; i < Str.length; i++) {
      code = Str.charCodeAt(i);
      if (code > 255) {
        len += 2;
      } else {
        len += 1;
      }
      if (len > num && state === true) {
        limit = i;
        state = false;
      }
    }
    if (needPoint) {
      return {
        selflen: len,
        limitIndex: limit,
        str: Str.slice(0, limit) + "..."
      };
    } else {
      return {
        selflen: len,
        limitIndex: limit,
        str: Str.slice(0, limit)
      };
    }
  },
  /*
   *定时器
   * @params start: 按钮点击时触发的函数
   * @params ing: 定时器正在执行的过程中触发的函数
   * @params end: 定时器执行结束之后触发的函数
   * @params n: 倒计时从多少开始，不传，默认60秒
   * */
  startTime: function (start, ing, end, n) {
    let num = n || 60;
    let off = true;
    let times = null;
    if (off === false) {
      return;
    }
    start(num);
    off = false;
    times = setInterval(function () {
      num--;
      if (num === 0) {
        off = true;
        num = n || 60;
        clearInterval(times);
        end(num);
        return;
      }
      ing(num, times);
    }, 1000);
  },
  /*
   *将金额后面添加 .00 的功能
   * @params num 传递进来的数字或者字符串
   * */
  addPoint: function (num) {
    if (!this.valadateNumber(num)) {
      return new Error("请传递进来一个数字");
    }
    if (!num) {
      num = 0;
    }
    const ns = String(num);
    if (ns.indexOf(".") === -1) {
      return ns + ".00";
    } else {
      return ns;
    }
  },
  /*
   *验证金额的功能
   * @params value 传递进来的金额
   * @params num 限制的金额长度 无限制请传递+
   * @return 返回一个正确的金额类型
   * */
  validateMoney(value, num) {
    if (!Vue || !Toast) {
      return new Error("请在toolutil.js文件当中引入Vue和vant，否则程序无法运行");
    }
    // /^[0-9]+(.?[0-9]{1,2})?$/
    let moneyMax = num || 5;
    if (num === "+") {
      moneyMax = Infinity;
    }
    const val = value.toString();
    if (val === "") {
      Toast({
        message: "输入金额内容不能为空",
        position: "bottom",
        duration: 1000
      });
      return false;
    }
    if (val.indexOf(" ") !== -1) {
      Toast({
        message: "输入金额内容不能为空",
        position: "bottom",
        duration: 1000
      });
      return false;
    }
    if (isNaN(val)) {
      Toast({
        message: "请输入正确的金额类型",
        position: "bottom",
        duration: 1000
      });
      return false;
    }
    if (val.slice(0, 1) === "0") {
      if (val.slice(1, 2) !== ".") {
        Toast({
          message: "请输入正确的金额类型",
          position: "bottom",
          duration: 1000
        });
        return false;
      } else if (val.slice(1, 2) === "." && val.length === 2) {
        Toast({
          message: "请输入正确的金额类型",
          position: "bottom",
          duration: 1000
        });
        return false;
      }
    }
    if (val.indexOf(".") !== -1) {
      var left = val.split(".")[0];
      var right = val.split(".")[1];
      if (right.length > 2) {
        Toast({
          message: "请输入正确的金额类型",
          position: "bottom",
          duration: 1000
        });
        return false;
      }
      if (left.length > moneyMax) {
        Toast({
          message: "金额最大不能超过" + moneyMax + "位",
          position: "bottom",
          duration: 1000
        });
        return false;
      }
      //			val = left + "." + right;
    } else if (val.length > moneyMax) {
      Toast({
        message: "金额最大不能超过" + moneyMax + "位",
        position: "bottom",
        duration: 1000
      });
      return false;
    }
    return true;
  },
  /*
   *将金额后面添加 .00 的功能
   * @params val 传递进来的手机号码
   * */
  validatePhone(val, type) { // 验证手机号
    if (!Vue || !Toast) {
      return new Error("请在toolutil.js文件当中引入Vue和vant，否则程序无法运行");
    }
    if (val === "") {
      if (!type) {
        Toast({
          message: "手机号码不能为空",
          position: "bottom",
          duration: 1000
        });
      }
      return false;
    }
    if (!/^1(3|5|6|7|8|9)[0-9]{9}$/.test(val)) {
      if (!type) {
        Toast({
          message: "手机号码格式不正确",
          position: "bottom",
          duration: 1000
        });
      }
      return false;
    }
    return true;
  },
  /* 获取一串字符当中的数字
   * @params str 一串字符
   * @params limit 限制的字数 选填
   * */
  getStrNumber(str, limit) {
    if (!str || !str.match(/[0-9]/g)) {
      return "";
    }
    if (limit) {
      return str.match(/[0-9]/g).join("").slice(0, limit);
    }
    return str.match(/[0-9]/g).join("");
  },
  /* 验证是不是数字
   * @params str 要验证的数字
   * */
  valadateNumber(str) {
    if (isNaN(str)) {
      return false;
    }
    return true;
  },
  /*
   *将传入的日期转换成距离此时此刻的时段文字
   * @params val 传入的日期
   * */
  dateT(val) {
    const a = new Date(val);
    if (a === "Invalid Date") {
      return "";
    }
    const changeDate = a.getTime();
    const nowDate = new Date().getTime();
    const otherDate = nowDate - changeDate;
    if (otherDate < 0) {
      return "刚刚";
    }
    const year = parseInt(otherDate / 1000 / 60 / 60 / 24 / 365);
    if (year >= 1) {
      // return year + "年前";
      return val;
    }
    const month = parseInt(otherDate / 1000 / 60 / 60 / 24 / 31);
    if (month >= 1) {
      // return month +"个月前";
      return val;
    }
    const day = parseInt(otherDate / 1000 / 60 / 60 / 24);
    if (day < 7 && day > 0) {
      return day + "天前";
    } else if (day >= 7 && day < 14) {
      return "1周前";
    } else if (day >= 14) {
      return val;
    }
    const hh = parseInt(otherDate / 1000 / 60 / 60);
    if (hh >= 1) {
      return hh + "小时前";
    }
    const mm = parseInt(otherDate / 1000 / 60);
    if (mm >= 1) {
      return mm + "分钟前";
    }
    const ss = parseInt(otherDate / 1000);
    if (ss >= 1) {
      return "刚刚";
    }
  },
  // 加法处理过精度问题 num1加数1 | num2加数2
  numAdd: function (num1, num2) {
    var baseNum, baseNum1, baseNum2;
    try {
      baseNum1 = num1.toString().split(".")[1].length;
    } catch (e) {
      baseNum1 = 0;
    }
    try {
      baseNum2 = num2.toString().split(".")[1].length;
    } catch (e) {
      baseNum2 = 0;
    }
    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
    return (num1 * baseNum + num2 * baseNum) / baseNum;
  },
  // 减法 num1被减数  |  num2减数
  numSub: function (num1, num2) {
    var baseNum, baseNum1, baseNum2;
    var precision;// 精度
    try {
      baseNum1 = num1.toString().split(".")[1].length;
    } catch (e) {
      baseNum1 = 0;
    }
    try {
      baseNum2 = num2.toString().split(".")[1].length;
    } catch (e) {
      baseNum2 = 0;
    }
    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
    precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2;
    return ((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision);
  },
  // 乘法 num1被乘数 | num2乘数
  numMulti: function (num1, num2) {
    var baseNum = 0;
    try {
      baseNum += num1.toString().split(".")[1].length;
    } catch (e) {
    }
    try {
      baseNum += num2.toString().split(".")[1].length;
    } catch (e) {
    }
    return Number(num1.toString().replace(".", "")) * Number(num2.toString().replace(".", "")) / Math.pow(10, baseNum);
  },
  // 除法 num1被除数 | num2除数
  numDiv: function (num1, num2) {
    var baseNum1 = 0, baseNum2 = 0;
    var baseNum3, baseNum4;
    try {
      baseNum1 = num1.toString().split(".")[1].length;
    } catch (e) {
      baseNum1 = 0;
    }
    try {
      baseNum2 = num2.toString().split(".")[1].length;
    } catch (e) {
      baseNum2 = 0;
    }
    baseNum3 = Number(num1.toString().replace(".", ""));
    baseNum4 = Number(num2.toString().replace(".", ""));
    return (baseNum3 / baseNum4) * Math.pow(10, baseNum2 - baseNum1);
  },
  /**
 *张俊娜：2020/6/11
  *描述：获取地址栏参数
  *版本：1.0
  */
  getQueryString: function (name) {
    // 未传参，返回空
    if (!name) return null;
    // 查询参数：先通过search取值，如果取不到就通过hash来取
    var after = window.location.search;
    after = after.substr(1) || window.location.hash.split('?')[1];
    // 地址栏URL没有查询参数，返回空
    if (!after) return null;
    // 如果查询参数中没有"name"，返回空
    if (after.indexOf(name) === -1) return null;

    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    // 当地址栏参数存在中文时，需要解码，不然会乱码
    var r = decodeURI(after).match(reg);
    // 如果url中"name"没有值，返回空
    if (!r) return null;

    return r[2];
  },
  openApp: function (packgeName) { // js实现浏览器中打开app应用
    setTimeout(function () {
      location.href = "mimarket://details?id=" + packgeName;
    }, 500);
    setTimeout(function () {
      location.href = "samsungapps://ProductDetail/" + packgeName;
    }, 550);
    setTimeout(function () {
      location.href = "appmarket://details?id=" + packgeName;
    }, 600);
    setTimeout(function () {
      location.href = "oppomarket://details?packagename=" + packgeName;
    }, 650);
    setTimeout(function () {
      location.href = "vivomarket://details?id=" + packgeName;
    }, 700);
    setTimeout(function () {
      location.href = "https://sj.qq.com/myapp/detail.htm?apkName=" + packgeName; // 支付宝
    }, 750);
    // 		以下是常用的一些第三方应用的 schemer
    //		触宝拨号：dialer://
    //		蜂窝网络：prefs:root=MOBILE_DATA_SETTINGS_ID
    //		WIFI：prefs:root=WIFI（WIFI这几个字母一定要大写）
    //		定位服务：prefs:root=LOCATION_SERVICES
    //		微信 :weixin://
    //		备忘录：mobilenotes://
    //		百度贴吧:tencent100385258://
    //		高德地图：iosamap://
    //		今日头条 snssdk141://
    //		挖财记账 wacai://
    //		QQ音乐 :QQmusic://
    //		百度音乐:baidumusic://
    //		猎豹浏览器:sinaweibosso.422729959://
    //		UC浏览器:ucbrowser://
    //		百度云:baiduyun://
    //		淘宝网:taobao://
    //		支付宝:alipay://
    //		新浪微博:weibo://
    //		优酷:youku://
    //		百度地图:baidumap://
    //		QQ:mqq://
    //		QQ浏览器:qq browser://
    //		节奏大师:节奏大师tencentrm://
    //		刀塔传奇:刀塔传奇teiron2273://
    //		天天动听:ttpod://
    //		淘宝taobao://
    //		点评dianping:// dianping://search
    //		名片全能王camcard://
    //		支付宝alipay://
    //		豆瓣fm：doubanradio://
    //		微盘 sinavdisk://
    //		网易公开课ntesopen://
    //		美团 i**://
    //		京冬openapp.jdmoble://
    //		人人renren://
    //		我查查 wcc://
    //		1号店wccbyihaodian://
    //		有道词典yddictproapp://
    //		知乎zhihu://
    //		墨客 com.moke.moke-1://
    //		名片全能王 camcard://
    //		扫描全能王 camscanner://
    //		TuneIn Radio tunein:// 或 tuneinpro://
    //		OfficeSuite mobisystemsofficesuite://
    //		WPS Office KingsoftOfficeApp://
    //		Line line://
    //		1Password onepassword://
    //		Clear(著名的Todo应用) clearapp://
    //		Chrome谷歌浏览器 googlechrome://
    //		Calendars 5 calendars://
    //		GoodReader 4 com.goodreader.sendtogr://
    //		PDF Expert 5 pdfexpert5presence://
    //		Documents 5 rdocs://
    //		nPlayer nplayer-http://
    //		GPlayer gplayer://
    //		AVPlayer HD AVPlayerHD://
    //		AVPlayer AVPlayer://
    //		Ace Player aceplayer://
    //		12306订票助手 trainassist://
    //		金山词霸 com.kingsoft.powerword.6://
    //		节奏大师 tencentrm://
    //		赶集生活 **://
    //		凤凰新闻 comIfeng3GifengNews://
    //		高铁管家 gtgj://
    //		飞信 fetion://
    //		豆瓣FM doubanradio://
    //		大智慧 dzhiphone://
    //		布卡漫画 buka://
    //		爱奇艺PPS ppstream://
    //		哔哩哔哩动画 bilibili://
    //		56视频 com.56Video://
    //		365日历 rili365://
    //		58同城 wbmain://
    //		遇见 iaround://
    //		陌陌 momochat://
    //		旺旺卖家版 wangwangseller://
    //		有道词典 yddict://
    //		掌阅iReader iReader://
    //		艺龙旅行 elongIPhone://
    //		迅雷+迅雷云播 thunder://
    //		熊猫公交 wb1405365637://
    //		携程无线 CtripWireless://
    //		无线苏州 SuZhouTV://
    //		唯品会 vipshop://
    //		微视 weishiiosscheme://
    //		微拍 wpweipai://
    //		旺信 wangxin://
    //		网易公开课 ntesopen://
    //		网易将军令 netease-mkey://
    //		万年历 youloft.419805549://
    //		土豆视频 tudou://
    //		同花顺 amihexin://
    //		天涯社区 tianya://
    //		天气通Pro sinaweatherpro://
    //		天气通 sinaweather://
    //		墨迹天气 rm434209233MojiWeather://
    //		腾讯新闻 qqnews://
    //		腾讯微云 weiyun://
    //		腾讯地图 sosomap://
    //		淘宝旅行 taobaotravel://
    //		人人 renrenios://
    //		蜻蜓FM qtfmp://
    //		浦发银行 wx1cb534bb13ba3dbd://
    //		招商银行 cmbmobilebank://
    //		支付宝 alipay://
    //		建设银行 wx2654d9155d70a468://
    //		工商银行 com.icbc.iphoneclient://
    //		酷我音乐 com.kuwo.kwmusic.kwmusicForKwsing://
    //		酷狗音乐 kugouURL://
    //		京东 openApp.jdMobile://
    //		QQ音乐 qqmusic://
    //		QQ斗地主 tencent382://
    //		QQ浏览器 mttbrowser://
    //		QQ安全中心 qmtoken://
    //		QQ国际版 mqqiapi://
    //		PPTV pptv://
    //		爱奇艺视频 qiyi-iphone://
    //		暴风影音 com.baofeng.play://
    //		保卫萝卜2 wb2217954495://
    //		保卫萝卜 wb1308702128://
    //		百度音乐 baidumusic://
    //		百度视频 baiduvideoiphone:// 或 bdviphapp://
    //		百度糯米 bainuo://
    //		百度魔图 photowonder://
    //		百度魔拍 wondercamera://
    //		百度地图 baidumap://
    //		百度导航 bdNavi://
    //		百度 baiduboxapp:// 或 BaiduSSO://
    //		搜狗输入法 com.sogou.sogouinput://
    //		搜狐视频 sohuvideo-iphone:// 或 sohuvideo://
    //		搜狐新闻 sohunews://
    //		随手记 FDMoney://
    //		腾讯企业邮箱 qqbizmailDistribute2://
    //		腾讯手机管家 mqqsecure://
    //		腾讯视频 tenvideo:// 或 tenvideo2:// 或 tenvideo3://
    //		腾讯微博 TencentWeibo://
    //		天猫 tmall://
    //		天天星连萌 tencent100689806://
    //		天天爱消除 tencent100689805://
    //		天天酷跑 tencent100692648://
    //		天天飞车 tencent100695850://
    //		天天动听 ttpod://
    //		威锋网 com.weiphone.forum://
    //		新浪微博 weibo:// 或 sinaweibo://
    //		网易邮箱 neteasemail://
    //		百度输入法 BaiduIMShop://
    //		UC浏览器 ucbrowser://
    //		E-Mail MESSAGE://
  },
  /**
   *王伟东：2020年8月12日14:41:12
   *描述：弹框
   *版本：1.0
   */
  toast: function (obj) {
    var $ = jquery;
    var template = $(
      "<span class='xyjdialog' style='font-size: 0.28rem;white-space:nowrap;word-break: break-all;color: white;border-radius: 0.05rem;padding: 0.08rem 0.16rem;position: fixed;z-index: 999;bottom: 0.8rem;margin: 0 auto;background: rgba(0,0,0,0.8);transition: all .8s;'>" +
      (obj.message ? obj.message : obj) + "</span>");
    if ($(".xyjdialog").length == 0) {
      $("body").append(template);
      var width = $(".xyjdialog").width();
      $(".xyjdialog").css("left", "calc(50% - " + width / 2 + "px)");
      setTimeout(function () {
        $(".xyjdialog").css("opacity", 0);
        setTimeout(function () {
          $(".xyjdialog").remove();
        }, 800);
      }, obj.duration ? obj.duration : 1000);
    }
  },
  /**
   *王伟东：2020/3/6 17:02
   *描述：判断当前项目运行环境
   *版本：1.0
   */
  judgeEnviroment: function () {
    var ua = navigator.userAgent;
    var isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Linux") > -1;
    var isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (ua.indexOf("MicroMessenger") !== -1 && ua.indexOf("iPhone") > -1) {
      return "weixinAndIos";
    }
    if (ua.indexOf("MicroMessenger") !== -1) {
      return "weixin";
    }
    if (isAndroid) {
      return "android";
    }
    if (isIOS) {
      return "ios";
    }
  },
  /**
   *宋建国：2020/1/12 22:20
   *描述：返回对象类型
   *版本：1.0
   */
  isClass: function (o) {
    if (o === null) return "Null";
    if (o === undefined) return "Undefined";
    return Object.prototype.toString.call(o).slice(8, -1);
  },
  /**
   *宋建国：2020/2/29 0:48
   *描述：获取屏幕宽度与高度
   *版本：1.0
   */
  screenWH: function (then) {
    let result = null;
    if (then.$tu.isBlank(then.$store.state.app.drapRoutePath)) {
      result = {
        width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
        height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      };
    } else {
      result = {
        width: 414,
        height: 736
      };
    }
    return result;
  },
  /**
   *宋建国：2020/3/24 15:11
   *描述：获取localStorage已使用大小M
   *版本：1.0
   */
  localSize: function () {
    let sizeStore = 0;
    if (window.localStorage) {
      for (const item in window.localStorage) {
        sizeStore = sizeStore + window.localStorage.getItem(item).length;
      }
    }
    return (sizeStore / 1024 / 1024).toFixed(2) + "M";
  },
  /**
   *wwd：2020年8月12日14:33:11
   *描述：判断当前链接是否可以访问
   *版本：1.0
   */
  urlIsLoad: function (_url, callback) {
    jquery.ajax({
      url: _url,
      type: "get",
      success: function () {
        // 可以访问
        callback(true);
      },
      fail: function () {
        // 不可以访问
        callback(false);
      }
    });
  },
  /**
   *wwd：2020年8月12日14:33:11
   *描述：复制文本到剪切板
   *版本：1.0
   */
  copyUrl: function (str) {
    var Url2 = str;
    var oInput = document.createElement("input");
    oInput.value = Url2;
    document.body.appendChild(oInput);
    oInput.select(); // 选择对象
    document.execCommand("Copy"); // 执行浏览器复制命令
    oInput.remove();
    this.toast("复制成功");
  },
  /**
   * @author 张俊娜
   * @param {String} date - 需要判断的日期
   * @returns {Boolean} 如果是今天 那么返回true 否则返回false
   * @version 1.0.0
   * @description 判断日期是否是今天
   * @public
   **/
  isToday: function (date) {
    let d = new Date(date.toString().replace(/-/g, "/"));
    let todaysDate = new Date();
    if (d.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
      return true;
    } else {
      return false;
    }
  },
  /**
   * @author 王伟东
   * @version 1.0.0
   * @description 获取图片的base64格式
   * @public
   * */
  getBase64Image: function (img) {
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, img.width, img.height);
    var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
    var dataURL = canvas.toDataURL("image/" + ext);
    return dataURL;
  },
  /**
   *wwd：2020年9月25日14:33:11
   *描述：获取rem在手机上展示的实际尺寸
   *版本：1.0
   */
  getFontSize: function (rem) {
    return rem * parseFloat(document.getElementsByTagName("html")[0].style.fontSize);
  },
  /**
   *wwd：2021-1-19 14:32:09
   *描述：ios和安卓壳方法转换函数
   *版本：1.0
   */
  appInterFace: function (method, jsonStr) {
    if (!method) {
      window.console.error("方法名不能为空");
      return;
    }

    if (this.judgeEnviroment() == "ios") { // ios
      if (!jsonStr) {
        var fn = window.prompt(method);
        if (typeof fn == "string") {
          return JSON.parse(fn);
        }
        return fn;
      } else {
        jsonStr = JSON.stringify(jsonStr);
        return JSON.parse(window.prompt(method, jsonStr));
      }
    } else { // android
      if (typeof window.AppInterace == "object" && typeof window.AppInterace[method] == "function") {
        if (!jsonStr) {
          return JSON.parse(window.AppInterace[method]());
        } else {
          jsonStr = JSON.stringify(jsonStr);
          return JSON.parse(window.AppInterace[method](jsonStr));
        }
      } else {
        var str = method + "方法不存在<br/>参数：" + jsonStr;
        window.console.error(str);
      }
    }
  },


  /*
   * wwd 传入日期转换成多少小时分钟秒
   * @params time: 传入的时间数值
   * */
  getAppointToNowTimeTxt(times) {
    let dateMat = new Date(times);
    if (dateMat == "Invalid Date") {
      dateMat = new Date(times.replace(/-/g, "/"));
      if (dateMat == "Invalid Date") {
        return "";
      }
    }
    var time = dateMat.getTime();
    var day = "";
    var hour = "";
    var min = "";
    var second = "";
    day = time / 1000 / 60 / 60 / 24;
    hour = (time / 1000 / 60 / 60) % 24;
    min = (time / 1000 / 60) % 60;
    second = (time / 1000) % 60;
    if (day < 1) {
      return this.formatNumber(hour) + "小时" + this.formatNumber(min) + "分钟" + this.formatNumber(second) + "秒";
    } else {
      return this.formatNumber(day) + "天" + this.formatNumber(hour) + "小时" + this.formatNumber(min) + "分钟" + this.formatNumber(
        second) + "秒";
    }
  },
  _rec: null, // 录音对象 静态变量
  /*
   * wwd h5录音
   * type： 0结束录音 1开始录音
   * callback：结束录音的回调实例
   * failCallback: 失败回调
   * */
  recordSound(type, callback, failCallback,vueEle) {
    var self = this;

    /**调用open打开录音请求好录音权限**/
    var recOpen = function (success) {//一般在显示出录音按钮或相关的录音界面时进行此方法调用，后面用户点击开始录音时就能畅通无阻了
      if (self._rec) {
        success && success();
        return;
      }
      self._rec = vueEle.Recorder({
        type: "mp3",
        sampleRate: 16000,
        bitRate: 16, //mp3格式，指定采样率hz、比特率kbps，其他参数使用默认配置；注意：是数字的参数必须提供数字，不要用字符串；需要使用的type类型，需提前把格式支持文件加载进来，比如使用wav格式需要提前加载wav.js编码引擎
        onProcess: function (buffers, powerLevel, bufferDuration, bufferSampleRate, newBufferIdx, asyncEnd) {
          //录音实时回调，大约1秒调用12次本回调
          //可利用extensions/waveview.js扩展实时绘制波形
          //可利用extensions/sonic.js扩展实时变速变调，此扩展计算量巨大，onProcess需要返回true开启异步模式
        }
      });

      //var dialog=createDelayDialog(); 我们可以选择性的弹一个对话框：为了防止移动端浏览器存在第三种情况：用户忽略，并且（或者国产系统UC系）浏览器没有任何回调，此处demo省略了弹窗的代码
      self._rec.open(function () {//打开麦克风授权获得相关资源
        //dialog&&dialog.Cancel(); 如果开启了弹框，此处需要取消
        //rec.start() 此处可以立即开始录音，但不建议这样编写，因为open是一个延迟漫长的操作，通过两次用户操作来分别调用open和start是推荐的最佳流程
        success && success();
      }, function (msg, isUserNotAllow) {//用户拒绝未授权或不支持
        //dialog&&dialog.Cancel(); 如果开启了弹框，此处需要取消
        failCallback(msg)
        console.log((isUserNotAllow ? "UserNotAllow，" : "") + "无法录音:" + msg);
      });
    };

    /**开始录音**/
    function recStart() {//打开了录音后才能进行start、stop调用
      self._rec.start();
    };
    /**结束录音**/
    function recStop() {
      self._rec.stop(function (blob, duration) {
        console.log(blob, (window.URL || webkitURL).createObjectURL(blob), "时长:" + duration + "ms");
        self._rec.close();//释放录音资源，当然可以不释放，后面可以连续调用start；但不释放时系统或浏览器会一直提示在录音，最佳操作是录完就close掉
        self._rec = null;
        callback({blob, duration})
        //已经拿到blob文件对象想干嘛就干嘛：立即播放、上传

        // /*** 【立即播放例子】 ***/
        // var audio = document.createElement("audio");
        // audio.controls = true;
        // document.body.appendChild(audio);
        // //简单利用URL生成播放地址，注意不用了时需要revokeObjectURL，否则霸占内存
        // audio.src = (window.URL || webkitURL).createObjectURL(blob);
        // audio.play();
      }, function (msg) {
        console.log("录音失败:" + msg);
        failCallback(msg)
        self._rec.close();//可以通过stop方法的第3个参数来自动调用close
        self._rec = null;
      });
    };
    //这里假设立即运行，只录3秒，录完后立即播放，本段代码copy到控制台内可直接运行

    recOpen(function () {
      if (type == 0) {
        recStop();
      } else if (type == 1) {
        recStart();
      }
    });
  },
  // wwd 2021年5月8日10:59:11
  // 上传音频文件
  // @params api: 上传图片地址
  uploadSoundFile(blob,callback,vueEle) {
    var form=new FormData();
    form.append("file",blob,"recorder.mp3"); //和普通form表单并无二致，后端接收到upfile参数的文件，文件名为recorder.mp3
    jquery.ajax({
      url: vueEle.zuul + "/xyj-admin/w/FileUploadController/uploadFile", //上传接口地址
      headers:{
        token: "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsImV4cCI6NDYxMTY4NzU3MDcxMDU3NiwiY3JlYXRlZCI6MTU1MjI4MzE4ODExOSwiYXV0aG9yaXRpZXMiOlt7ImF1dGhvcml0eSI6InN5czp1c2VyOnZpZXcifSx7ImF1dGhvcml0eSI6InN5czptZW51OmRlbGV0ZSJ9LHsiYXV0aG9yaXR5Ijoic3lzOmRlcHQ6ZWRpdCJ9LHsiYXV0aG9yaXR5IjoiZGljdDpjb21wYW55OmFkZCJ9LHsiYXV0aG9yaXR5Ijoic3lzOmRpY3Q6ZWRpdCJ9LHsiYXV0aG9yaXR5Ijoic3lzOmRpY3Q6ZGVsZXRlIn0seyJhdXRob3JpdHkiOiJzeXM6bWVudTphZGQifSx7ImF1dGhvcml0eSI6InN5czp1c2VyOmFkZCJ9LHsiYXV0aG9yaXR5IjoiZGljdDpjb21wYW55OnZpZXcifSx7ImF1dGhvcml0eSI6InN5czpsb2c6dmlldyJ9LHsiYXV0aG9yaXR5Ijoic3lzOmRlcHQ6ZGVsZXRlIn0seyJhdXRob3JpdHkiOiJzeXM6cm9sZTplZGl0In0seyJhdXRob3JpdHkiOiJzeXM6cm9sZTp2aWV3In0seyJhdXRob3JpdHkiOiJkaWN0OmNvbXBhbnk6ZWRpdCJ9LHsiYXV0aG9yaXR5Ijoic3lzOmRpY3Q6dmlldyJ9LHsiYXV0aG9yaXR5Ijoic3lzOnVzZXI6ZWRpdCJ9LHsiYXV0aG9yaXR5Ijoic3lzOnVzZXI6ZGVsZXRlIn0seyJhdXRob3JpdHkiOiJzeXM6ZGVwdDp2aWV3In0seyJhdXRob3JpdHkiOiJzeXM6ZGVwdDphZGQifSx7ImF1dGhvcml0eSI6InN5czpyb2xlOmRlbGV0ZSJ9LHsiYXV0aG9yaXR5Ijoic3lzOm1lbnU6dmlldyJ9LHsiYXV0aG9yaXR5Ijoic3lzOm1lbnU6ZWRpdCJ9LHsiYXV0aG9yaXR5Ijoic3lzOmRpY3Q6YWRkIn0seyJhdXRob3JpdHkiOiJzeXM6cm9sZTphZGQifV19.zqeykmLqQRADkfKhQSqltd_q0llDoRfNH4FUYwcdFkWk5KbuWT9e90wZQjYMZldBDtC_XtzyvPHbsHpPJfQHSg"
      },
      type: "POST",
      contentType:false,
      processData:false,
      data: form,
      success: function (v) {
        callback("success",v)
      },
      error: function (s) {
        callback("fail",s)
      }
    });
  },
  /*@Description: 类继承函数
   *@Author: 宋建国
   *@Date: 2021-05-30 10:27:16
   *@param {function} subClass 待继承的子类
   *@param {function} superClass 待被继承的父类
   *@exception {Error} 参数不合法时抛出异常
  */
  inherit(subClass,superClass){
    if(arguments.length !== 2){
      throw new Error("只能传入子类与父类两个参数");
    }
    for(let i=0; i<arguments.length; i++){
      if(typeof arguments[i] !== "function"){
        throw new Error("子类与父类必须是函数才能继承");
      }
    }
    var oSuper = new superClass();
    for(let key in oSuper){
      if(!subClass.prototype[key]){
        subClass.prototype[key] = oSuper[key];
      }
    }
    subClass.prototype.constructor = subClass;
  }
};



// WEBPACK FOOTER //
// ./src/utils/toolutil.js